import { Injectable } from '@angular/core';
import { ForecastDocumentDetails } from '../../create-multiple-forecast/forecast-document-details';
import { PreferenceType } from '../../../shared/enums/preference-type';

@Injectable({ providedIn: 'root' })
export class CreatePortfolioForecastService {

  public patents: ForecastDocumentDetails[] = [];

  public title: string;

  public team: number;

  public formTouched: boolean;

  // Which preference set the whole forecast draws its saved models, fees and report currency from.
  public preferenceType: PreferenceType = PreferenceType.UserPreference;

  constructor() {}

  public remove(selectedPatent: ForecastDocumentDetails): void {
    this.patents = this.patents.filter(patent => patent !== selectedPatent);
  }

  public clear(): void {
    this.patents = [];
    this.title = undefined;
    this.team = undefined;
    this.formTouched = undefined;
    this.preferenceType = PreferenceType.UserPreference;
  }
}
